export default {
    methods: {
        isSubstanceSelected(group, item) {
            if (!group || !item) {
                return false
            }
            if (item.isNoSubstance) {
                return false
            }
            return group.substances.some(sub => sub.substanceId === item.id)
        },
        getSubstanceOption(substance) {
            if (!substance || !substance.substanceId) {
                return null
            }
            return {
                id: substance.substanceId,
                name: substance.substanceName,
                title: substance.substanceName,
                cas: substance.substanceCas,
                ec: substance.substanceEc,
            }
        },
        getSubstanceMeta(group, index) {
            const substance = group.substances && group.substances[index]
            if (!substance) {
                return ''
            }
            if (substance.noSubstance) {
                return ''
            }
            const parts = []
            if (substance.substanceCas) {
                parts.push(`CAS: ${substance.substanceCas}`)
            }
            if (substance.substanceEc) {
                parts.push(`EC: ${substance.substanceEc}`)
            }
            return parts.join(' · ')
        },
    },
}
